export const URL_ROOT = process.env.REACT_APP_API_ENDPOINT
